import { Link } from "react-router-dom";

const ENTRIES = [
  {
    type: "电影",
    icon: "ri-movie-2-line",
    desc: "院线新片、口碑佳作与类型回顾",
    count: "10 部作品",
    tone: "primary"
  },
  {
    type: "电视剧",
    icon: "ri-tv-2-line",
    desc: "古装权谋、都市情感与年代群像",
    count: "12 部作品",
    tone: "accent"
  },
  {
    type: "网络剧",
    icon: "ri-smartphone-line",
    desc: "悬疑、轻喜剧与青春成长题材",
    count: "8 部作品",
    tone: "secondary"
  }
];

export default function CategoryEntry() {
  return (
    <section className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6 md:py-16 lg:px-8">
      <div className="flex items-end justify-between gap-4">
        <div>
          <h2 className="font-heading text-2xl font-extrabold text-foreground-950 md:text-3xl">分类快捷入口</h2>
          <p className="mt-2 text-sm text-foreground-600">按内容形态快速进入，找到你想了解的那一类作品。</p>
        </div>
        <Link
          to="/category"
          className="hidden shrink-0 items-center gap-1 text-sm font-medium text-primary-600 transition-colors hover:text-primary-700 md:inline-flex"
        >
          全部分类
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="mt-7 grid grid-cols-1 gap-5 sm:grid-cols-3">
        {ENTRIES.map((entry) => (
          <Link
            key={entry.type}
            to={`/category?type=${encodeURIComponent(entry.type)}`}
            className="group flex flex-col rounded-xl border border-background-200 bg-background-50 p-6 transition-colors hover:border-primary-300 hover:bg-background-100"
          >
            <span
              className={`flex h-14 w-14 items-center justify-center rounded-lg ${
                entry.tone === "primary"
                  ? "bg-primary-100 text-primary-700"
                  : entry.tone === "accent"
                    ? "bg-accent-100 text-accent-700"
                    : "bg-secondary-100 text-secondary-700"
              }`}
            >
              <i className={`${entry.icon} text-2xl`}></i>
            </span>
            <h3 className="mt-5 font-heading text-xl font-bold text-foreground-950">{entry.type}</h3>
            <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{entry.desc}</p>
            <div className="mt-5 flex items-center justify-between text-sm">
              <span className="text-foreground-500">{entry.count}</span>
              <span className="flex items-center gap-1 font-medium text-primary-600 transition-transform group-hover:translate-x-0.5">
                进入分类
                <i className="ri-arrow-right-line"></i>
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}